import { useMemo } from "react";
import { profileEditList, type TProfileEditLink } from "../constants";

type UseProfileNavigationProps = {
  currentType: TProfileEditLink;
  onNavigate: (type: TProfileEditLink) => void;
};

export function useProfileNavigation({
  currentType,
  onNavigate,
}: UseProfileNavigationProps) {
  // Find current index
  const currentIndex = useMemo(
    () => profileEditList.findIndex((item) => item.link === currentType),
    [currentType]
  );

  // Check boundaries
  const isFirstStep = currentIndex === 0;
  const isLastStep = currentIndex === profileEditList.length - 1;

  // Get current step info
  const currentStep = useMemo(
    () => profileEditList[currentIndex],
    [currentIndex]
  );

  // Navigation handlers
  const goToPrev = () => {
    if (!isFirstStep) {
      const prevLink = profileEditList[currentIndex - 1].link;
      onNavigate(prevLink);
    }
  };

  const goToNext = () => {
    if (!isLastStep) {
      const nextLink = profileEditList[currentIndex + 1].link;
      onNavigate(nextLink);
    }
  };

  const goToStep = (type: TProfileEditLink) => {
    onNavigate(type);
  };

  return {
    currentIndex,
    currentStep,
    isFirstStep,
    isLastStep,
    totalSteps: profileEditList.length,
    goToPrev,
    goToNext,
    goToStep,
    canGoNext: !isLastStep,
    canGoPrev: !isFirstStep,
  };
}
